module.exports = __webpack_public_path__ + "media/ken.dde8c0d6.wav";